import React, { useState, useContext, useEffect, useRef } from 'react'
import { NavLink, useLocation, useHistory } from 'react-router-dom'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import CustomDialog from '../../../components/organisms/Dialog'
import {
    Badge,
    Button,
    Divider,
    ListItem,
    Menu,
    MenuItem,
    SwipeableDrawer,
} from '@material-ui/core'
import AuthContext from '../../../../product/context/auth/authContext'
import CommonContext from '../../../../product/context/common/commonContext'
import UserContext from '../../../../product/context/user/userContext'
import AlertContext from '../../../../product/context/alert/alertContext'
import NorthCapitalContext from '../../../../product/context/payment/northcapital/northcapitalContext'
import { handleRedirectInternal } from '../../../../product/common/components'
import './Header.css'
import ProductContext from '../../../../product/context/product/productContext'
import BidHistory from '../../../components/organisms/BidHistory'
import TTWBidHistory from '../../../components/organisms/TTWBidHistory'
import KYCUpdate from '../../../components/organisms/KYCUpdate'
import BuynowContext from '../../../../product/context/buynow/buynowContext'
import Loaders from '../Loaders'
import MenuList from '@material-ui/core/MenuList'
import { makeStyles } from '@material-ui/core/styles'
import Popover from '@material-ui/core/Popover'
import { IconButton } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { LOGO, LOGO_WHITE } from '../../../../Utils'
import SideNavBar from '../SideNavBar'
import FreeShares from '../../organisms/FreeShares'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import FormDialog from '../../../../product/components/organisms/Dialog'
import classNames from 'classnames'
import { capitalizeFirstLetter } from '../../../common/components'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: 9999,
    },
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
}))

const Header = () => {
    const classes = useStyles()
    const [aucopen, setAucOpen] = React.useState(false)
    const [menu, setMenu] = React.useState('auction')
    const [userType, setUserType] = useState(0)
    const anchorRef = React.useRef(null)
    const [showNonResident, setShowNonResident] = useState(false)
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const commonContext = useContext(CommonContext)
    const productContext = useContext(ProductContext)
    const [documentUploaded, setDocumentUploaded] = useState(false)
    const [accountPopup, setAccountPopup] = useState(false)
    const [kycAdminReview, setKycAdminReview] = useState(false)
    const [verify, setVerify] = useState(false)
    const [dismissVerifyStartBanner, setDismissVerifyStartBanner] = useState(false)
    const [recentTransactions, setRecentTransactions] = useState([])
    const buynowContext = useContext(BuynowContext)

    const {
        updateProfile,
        responseStatus: responseStatusUser,
        sendEmailVerifyLink,
        getCompanyOwners,
        company_owner_data,
    } = useContext(UserContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { setAlert } = alertContext
    const {
        user,
        isAuthenticated,
        loadPendingCount,
        loadPendingTempCount,
        isAdmin,
        cartTempCount,
        cartCount,
        logout,
    } = authContext
    const {
        getOffers,
        freeOffers,
        clearOffers,
        toggleDialogCanada,
        setToggleDialogCanada,
        canadaUserErrorMessage,
    } = customCommonContext
    const [freePopup, setFreePopup] = useState(false)
    const [userVerify, setUserVerify] = useState('')
    const [freeData, setFreeData] = useState([])
    const [welcomePopup, setWelcomePopup] = useState(false)

    const [restrictPopup, setRestrictPopup] = useState(false)

    const [state, setState] = useState({
        right: false,
        top: false,
    })
    const history = useHistory()
    const [anchormenu, setanchormenu] = useState(null)
    const [anchorcart, setanchorcart] = useState(null)
    const [initLoad, setInitLoad] = useState(false)

    const { getAllSearchProducts, clearResponse } = productContext

    const { getAllCartProducts, search_allproducts } = buynowContext
    const {
        northCapitalUser,
        getUserDetails,
        north_capital_bank_details,
        getExternalAccount,
        north_capital_card_details,
        addCampaignContact,
        getCreditCard,
        getLinkedCreditCard,
    } = useContext(NorthCapitalContext)

    // Derived directly from the context data every render (not mirrored into their
    // own useState via a separate effect) — this used to be `bank`/`card`/
    // `paymentStatusKnown` state set by a useEffect a render behind
    // north_capital_bank_details/north_capital_card_details arriving. Because
    // north_capital_bank_details and north_capital_card_details are two independent
    // API calls that can resolve at different times, that extra render created a
    // window where `paymentStatusKnown` could already be true while `bank`/`card`
    // hadn't caught up to the freshly-loaded data yet, making the "Add a payment
    // method" banner flash true→false→true on every refresh even for accounts that
    // already have a payment method on file. Computing all three in the same render
    // as the source data removes that window — same conditions, no extra render lag.
    const bank = !!(
        north_capital_bank_details &&
        north_capital_bank_details.data &&
        north_capital_bank_details.data.statusDesc &&
        north_capital_bank_details.data.statusDesc.AccountNumber
    )
    const card = !!(
        north_capital_card_details &&
        north_capital_card_details.data &&
        north_capital_card_details.data.creditcardDetails &&
        north_capital_card_details.data.creditcardDetails.creditCardNumber
    )
    const paymentStatusKnown = !!(north_capital_bank_details && north_capital_card_details)

    const { searchValue, setSearchValue, isLoading } = commonContext
    const [kycProcessed, setKycProcessed] = useState(false)
    const [searchText, setSearchText] = useState('')
    let [cartProducts, setCartProducts] = useState([])
    const [showRecord, setShowRecord] = useState(false)
    const [hideRecord, setHideRecord] = useState(false)
    const [search, setSearch] = useState({})
    const [searchBox, setSearchBox] = useState(false)
    const [params, setParams] = useState(null)
    const location = useLocation()
    const [circle, setCircle] = useState({
        emailVerified: false,
        setupPaymentMethod: null,
        completedCompanyInfo: false,
        uploadedCompanyDetails: null,
        addedCompanyOwners: null,
        kycamlChecked: false,
        documentNeeded: true,
        accountVerified: false,
        showkeybtn: false,
        ownerkycamlChecked: false,
    })
    const mainMenu = useRef()

    const mobileSmall = useMediaQuery('(max-width:700px)')

    useEffect(async () => {
        let match,
            pl = /\+/g,
            search = /([^&=]+)=?([^&]*)/g,
            decode = function (s) {
                return decodeURIComponent(s.replace(pl, ' '))
            },
            query = window.location.search.substring(1)
        let urlParams = {}
        while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2])
        if (urlParams.search) {
            setSearchText(urlParams.search)
            if (location.pathname == '/search') {
                setInitLoad(true)
            }
        }
    }, [])
    useEffect(() => {
        if (initLoad) {
            setTimeout(function () {
                handleSearchButtonClick()
            }, 2000)
            setInitLoad(false)
        }
    }, [initLoad])

    useEffect(() => {
        if (isAuthenticated) {
            getLinkedCreditCard()
            getExternalAccount()
        }
    }, [isAuthenticated])

    const handleSearchBox = () => {
        setSearchBox(!searchBox)
    }

    const handleEmailVerify = () => {
        sendEmailVerifyLink({ email: user.email })
    }

    const handleVerify = () => {
        setVerify(true)
    }

    const enableOneof = false

    useEffect(() => {
        if (isAuthenticated) {
            getAllCartProducts(search)

            if (enableOneof) {
                getOffers({
                    email: user?.email ? user?.email : '',
                })
            }

            // if (history.location.search.includes('welcome=1')) {
            //     setWelcomePopup(true)
            // }
        }
    }, [isAuthenticated, user])

    useEffect(() => {
        if (isAuthenticated) {
            console.log('user?.purchase_blocked', user?.purchase_blocked, window.location.pathname)
            if (user && user?.purchase_blocked) {
                if (window.location.pathname !== '/account/profile') {
                    console.log('user?.purchase_blocked true')
                    setRestrictPopup(true)
                }
            }
        }
    }, [isAuthenticated, user])

    useEffect(() => {
        if (user && user?.id) {
            const givenDateStr = user.created_at
            const givenDate = new Date(givenDateStr)
            const currentDate = new Date()

            // Convert both dates to UTC for an accurate comparison
            const givenTime = Date.UTC(
                givenDate.getUTCFullYear(),
                givenDate.getUTCMonth(),
                givenDate.getUTCDate(),
            )
            const currentTime = Date.UTC(
                currentDate.getUTCFullYear(),
                currentDate.getUTCMonth(),
                currentDate.getUTCDate(),
            )

            // Calculate difference in days
            const diffInDays = (currentTime - givenTime) / (1000 * 60 * 60 * 24)

            if (diffInDays >= 1) {
                setShowRecord(true)
            } else {
                setShowRecord(false)
            }
        }
    }, [user])

    const markAccuntStatus = (ty) => {
        // Shallow copy, not an alias to the same object — mutating `circle` in
        // place and passing that identical reference to setCircle let React
        // bail out of re-rendering whenever every OTHER state update in the same
        // batch (verify/userVerify/kycProcessed) also happened to resolve to an
        // unchanged value: Object.is(circle, circle) is always true, so React
        // saw "no change" even though fields inside it had just been mutated
        // (e.g. setupPaymentMethod: null -> false). The DOM kept showing the
        // stale render until some unrelated interaction (any click that forced
        // its own re-render) incidentally picked up the already-mutated object.
        // A fresh object reference guarantees setCircle always registers as a
        // real change.
        let accountStatusObj = { ...circle }
        accountStatusObj.kycamlChecked = false
        // null (not false) — entities don't know yet whether owners exist until
        // company_owner_data loads below; false must mean "confirmed no owners",
        // not "haven't checked yet" (see the addedCompanyOwners flicker fix below).
        accountStatusObj.addedCompanyOwners = null

        if (ty == 'owner' || user?.user_type === 0) {
            accountStatusObj.addedCompanyOwners = true
            accountStatusObj.ownerkycamlChecked = true
        }

        if (ty == 'kyc') {
            accountStatusObj.kycamlChecked = true
        }

        if (ty == 'payment') {
            accountStatusObj.setupPaymentMethod = true
        } else if (paymentStatusKnown) {
            accountStatusObj.setupPaymentMethod = false
        }

        if (user && northCapitalUser) {
            accountStatusObj.emailVerified = user && !user.mail_verified ? false : true
            accountStatusObj.documentNeeded =
                user.domesticYN === 'international_account' ||
                //user.regType === 'company' ||
                user.user_type === 1
                    ? true
                    : false
            accountStatusObj.showkeybtn =
                user && (user.company_owner_updated || user.profile_updated) ? true : false

            const individualInternationalUser =
                userType == 0 && user.domesticYN == 'international_account' ? true : false

            /*             if (
                (northCapitalUser?.amlstatus === 'Approved' ||
                    northCapitalUser?.amlstatus === 'Auto Approved' ||
                    northCapitalUser?.amlstatus === 'Manually Approved') &&
                (northCapitalUser?.kycstatus === 'Approved' ||
                    northCapitalUser?.kycstatus === 'Auto Approved' ||
                    northCapitalUser?.kycstatus === 'Manually Approved')
            ) {
                accountStatusObj.kycamlChecked = true
                //accountStatusObj.showkeybtn = false
            } */

            if (
                ((userType === 1 || (userType === 0 && individualInternationalUser)) &&
                    (northCapitalUser?.amlstatus === 'Approved' ||
                        northCapitalUser?.amlstatus === 'Auto Approved' ||
                        northCapitalUser?.amlstatus === 'Manually Approved')) ||
                (userType === 0 &&
                    !individualInternationalUser &&
                    (northCapitalUser?.amlstatus === 'Approved' ||
                        northCapitalUser?.amlstatus === 'Auto Approved' ||
                        northCapitalUser?.amlstatus === 'Manually Approved') &&
                    (northCapitalUser?.kycstatus === 'Approved' ||
                        northCapitalUser?.kycstatus === 'Auto Approved' ||
                        northCapitalUser?.kycstatus === 'Manually Approved'))
            ) {
                accountStatusObj.kycamlChecked = true
                //accountStatusObj.showkeybtn = false
            }

            if (
                accountStatusObj.kycamlChecked ||
                (user.domesticYN === 'international_account' &&
                    user.mail_verified === 1 &&
                    northCapitalUser.isDocumentUploaded === 1) ||
                (user.domesticYN === 'domestic_account' &&
                    user.user_type === 0 &&
                    user.mail_verified === 1) ||
                (user.user_type === 1 && northCapitalUser.isDocumentUploaded === 1)
            ) {
                accountStatusObj.accountVerified = true
                accountStatusObj.uploadedCompanyDetails = true
            } else {
                accountStatusObj.accountVerified = false

                if (user && user.user_type === 1) {
                    if (northCapitalUser.isDocumentUploaded === 0) {
                        accountStatusObj.uploadedCompanyDetails = false
                    } else {
                        accountStatusObj.uploadedCompanyDetails = true
                    }
                } else if (
                    user &&
                    user.domicile == 'non-resident' &&
                    northCapitalUser.isDocumentUploaded === 0
                ) {
                    accountStatusObj.uploadedCompanyDetails = false
                    setDocumentUploaded(false)
                    setShowNonResident(true)
                } else if (
                    user &&
                    user.domesticYN !== 'domestic_account' &&
                    user.domicile == 'non-resident' &&
                    northCapitalUser.isDocumentUploaded === 1
                ) {
                    accountStatusObj.uploadedCompanyDetails = true
                    setDocumentUploaded(true)
                    setShowNonResident(false)
                } else {
                    accountStatusObj.uploadedCompanyDetails = false
                }
            }

            if (!user.socialsecurity && user.domicile != 'non-resident') {
                accountStatusObj.completedCompanyInfo = false
            } else {
                if (user.domicile) {
                    accountStatusObj.completedCompanyInfo = true
                } else {
                    accountStatusObj.completedCompanyInfo = false
                }
            }

            // Recomputed fresh every run (not just turned on) — kycAdminReview must be
            // able to clear back to false once the flagged review resolves, otherwise
            // it sticks true forever for the rest of the session and the final banner
            // keeps showing "Your Account Verification Is In Review" even after the
            // account becomes genuinely approved.
            let adminReviewNeeded = user.kyc_admin_review === 1 && user.kyc_check_failed >= 2

            if (
                user?.user_type === 1 /* &&
                (northCapitalUser?.amlstatus === 'Approved' ||
                    northCapitalUser?.amlstatus === 'Auto Approved' ||
                    northCapitalUser?.amlstatus === 'Manually Approved') */
            ) {
                let companyOwnerVerified = true
                if (company_owner_data && company_owner_data.record) {
                    // company_owner_data.record has actually loaded at this point (even
                    // if empty) — safe to resolve addedCompanyOwners to a real boolean
                    // instead of leaving it null. Confirmed via real data: uploading
                    // company documents resolves before the owners fetch does, and with
                    // addedCompanyOwners left at its old `false` default during that gap,
                    // the "Add Company Owners" banner flashed on for entities that (once
                    // the fetch actually completed) already had owners added.
                    accountStatusObj.addedCompanyOwners = company_owner_data.record.length > 0
                }
                if (
                    company_owner_data &&
                    company_owner_data.record &&
                    company_owner_data.record.length > 0
                ) {
                    company_owner_data.record.map((item, index) => {
                        // Compute verification from the owner's own amlstatus/kycstatus
                        // rather than trusting a raw item.verified field — that field
                        // isn't reliably populated by the API for manually-approved
                        // owners, which left ownerkycamlChecked stuck false (and the
                        // "Awaiting Review" banner stuck showing) even after an admin
                        // manually approved both the company and every owner.
                        const ownerAmlApproved =
                            item.amlstatus === 'Approved' ||
                            item.amlstatus === 'Auto Approved' ||
                            item.amlstatus === 'Manually Approved'
                        const ownerKycApproved =
                            item.kycstatus === 'Approved' ||
                            item.kycstatus === 'Auto Approved' ||
                            item.kycstatus === 'Manually Approved'
                        item.verified =
                            (item.domicile === 'non-resident' && ownerAmlApproved) ||
                            (item.domicile !== 'non-resident' &&
                                ownerAmlApproved &&
                                ownerKycApproved)

                        if (companyOwnerVerified && !item.verified) {
                            companyOwnerVerified = false
                        }
                        if (item.kyc_review === 1 && item.kyc_check_failed >= 2) {
                            adminReviewNeeded = true
                        }
                    })
                }

                //console.log(companyOwnerVerified)
                if (companyOwnerVerified) {
                    //console.log('ss')
                    //accountStatusObj.kycamlChecked = true
                    accountStatusObj.ownerkycamlChecked = true
                    accountStatusObj.showkeybtn = false
                } else {
                    //accountStatusObj.kycamlChecked = false
                    accountStatusObj.ownerkycamlChecked = false
                    /* accountStatusObj.showkeybtn = true */
                }
            }

            // Override: once kycstatus/amlstatus have actually resolved to an
            // approved-equivalent value for the company AND (for entities) every
            // owner is individually verified, treat kyc_admin_review/kyc_check_failed
            // as resolved history rather than "still pending" — the backend doesn't
            // reliably clear those two fields once an admin actually completes the
            // manual review, so without this override a company/owner that WAS
            // flagged, got manually reviewed, and is now genuinely approved kept
            // showing "Your Account Verification Is In Review" forever, even after a
            // refresh, because the stale flags never went away.
            const companyKycAmlApproved =
                (northCapitalUser?.kycstatus === 'Approved' ||
                    northCapitalUser?.kycstatus === 'Auto Approved' ||
                    northCapitalUser?.kycstatus === 'Manually Approved') &&
                (northCapitalUser?.amlstatus === 'Approved' ||
                    northCapitalUser?.amlstatus === 'Auto Approved' ||
                    northCapitalUser?.amlstatus === 'Manually Approved')

            if (
                companyKycAmlApproved &&
                (user?.user_type !== 1 || accountStatusObj.ownerkycamlChecked)
            ) {
                adminReviewNeeded = false
            }

            setKycAdminReview(adminReviewNeeded)

            /* if (
                user.kyc_check_failed > 0 &&
                user.kyc_check_failed % 2 == 0 &&
                northCapitalUser.isDocumentUploaded === 0
            ) {
                setUploadDocument(true)
            } */
        }

        const scrollToTop =
            accountStatusObj?.emailVerified &&
            accountStatusObj?.setupPaymentMethod &&
            accountStatusObj?.completedCompanyInfo &&
            accountStatusObj?.uploadedCompanyDetails &&
            accountStatusObj?.addedCompanyOwners
                ? true
                : false

        if (scrollToTop) {
            window.scrollTo(0, 200)
        }

        if (
            scrollToTop &&
            accountStatusObj?.kycamlChecked &&
            accountStatusObj?.ownerkycamlChecked
        ) {
            setUserVerify(1)
            accountStatusObj.showkeybtn = false
        } else {
            setUserVerify(0)
        }

        console.log(accountStatusObj, '++++')
        console.log(
            '[DEBUG raw inputs]',
            new Date().toISOString(),
            'northCapitalUser.kycstatus/amlstatus:',
            northCapitalUser?.kycstatus,
            northCapitalUser?.amlstatus,
            'company_owner_data.record:',
            company_owner_data?.record?.map((o) => ({
                id: o.id,
                kycstatus: o.kycstatus,
                amlstatus: o.amlstatus,
                isDocumentUploaded: o.isDocumentUploaded,
                kyc_check_failed: o.kyc_check_failed,
                domicile: o.domicile,
            })),
        )

        if (accountStatusObj?.kycamlChecked) {
            setKycProcessed(true)
        } else {
            setKycProcessed(false)
        }

        setCircle(accountStatusObj)
        setVerify(false)
    }

    useEffect(() => {
        if (user && Object.keys(user).length) {
            if (user.user_type === 1) {
                console.log(
                    '[DEBUG getCompanyOwners fired]',
                    new Date().toISOString(),
                    'northCapitalUser.kycstatus/amlstatus:',
                    northCapitalUser?.kycstatus,
                    northCapitalUser?.amlstatus,
                )
                getCompanyOwners({})
            }
            console.log('changed one')
        }
    }, [northCapitalUser, user])

    useEffect(() => {
        setVerify(true)
        if (card || bank) {
            console.log('going on this')
            markAccuntStatus('payment')
        } else {
            markAccuntStatus('')
        }
    }, [card, bank, northCapitalUser, user, company_owner_data, paymentStatusKnown])

    useEffect(() => {
        // console.log(search_allproducts.cartrecords)
        setCartProducts(
            search_allproducts.cartrecords.length && search_allproducts.cartrecords[0].cartItems
                ? search_allproducts.cartrecords[0].cartItems
                : [],
        )
    }, [search_allproducts])

    useEffect(() => {
        setCartProducts([])
        return () => {
            setCartProducts([])
        }
    }, [])

    const onLogOut = () => {
        logout()
        localStorage.removeItem('popup')
        setCount({
            auctionCount: 0,
            buynowCount: 0,
        })
        localStorage.removeItem('temp_user_id')
        localStorage.removeItem('ttw_temp_user_id')
        localStorage.removeItem('bidIncrease')
        setAlert('Logged out successfully', 'success')
        handleRedirectInternal(history, '')
        setanchormenu(null)
        setanchorcart(null)
        setSearchText('')
        clearOffers()
    }

    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open })
    }

    const handleCart = (event) => {
        setanchorcart(event.currentTarget)
    }
    const handleMenu = (event) => {
        setanchormenu(event.currentTarget)
    }

    const handleClose = (history, path) => {
        setanchormenu(null)
        setanchorcart(null)
        if (history && path && path !== 'backdropClick') {
            handleRedirectInternal(history, path)
        }
    }

    const listHandle = (value) => {
        let search = {
            filters: {
                auctiontype: {
                    value:
                        value == 'all_closed' || value == 'all'
                            ? ''
                            : value === 'all_ttw_closed'
                            ? 'ttw'
                            : value,
                    type: 'in',
                    field: 'p.auctiontype',
                },
            },
            market_status: ['open'],
            from: 'search',
        }
        if (value === 'all_closed') {
            search.market_status = ['closed', 'sold']
        } else if (value === 'all_ttw_closed') {
            search.market_status = ['sold']
        }

        return search
    }

    const getSearchBarObjet = (value) => {
        if (searchValue) {
            return {
                ...searchValue,
                filters: {
                    ...searchValue.filters,
                    searchbar: {
                        ...searchValue.filters.searchbar,
                        value: value,
                    },
                },
            }
        } else {
            return {
                limit: 12,
                page: 1,
                orderby: 'p.id, desc',
                order: '',
                filters: {
                    searchbar: {
                        value: value,
                        type: 'like',
                        field: 'p.title,p.desc_proc',
                    },
                },
            }
        }
    }

    const handleSearchTextChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleSearchButtonClick = async () => {
        setSearchBox(!searchBox)
        if (typeof searchText != 'undefined') {
            await setSearchValue(getSearchBarObjet(searchText))
            setState({ ...state, top: false })
            if (location.pathname != '/search') {
                handleRedirectInternal(history, 'search')
            }
            let match,
                pl = /\+/g,
                search = /([^&=]+)=?([^&]*)/g,
                decode = function (s) {
                    return decodeURIComponent(s.replace(pl, ' '))
                },
                query = window.location.search.substring(1)
            let urlParams = {}
            while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2])
            urlParams.search = searchText
            let queryparam = Object.entries(urlParams)
                .map(([key, val]) => `${key}=${val}`)
                .join('&')
            history.replace({
                search: queryparam,
            })
        } else {
            // setSearch({
            //     ...search,
            //     filters: {
            //         ...search.filters,
            //         searchbar: {
            //             ...search.filters.searchbar,
            //             value: searchValue.filters.searchbar.value,
            //         },
            //     },
            // })
        }
    }

    const handleSearchKeyDown = async (e) => {
        if (e.key === 'Enter') {
            await setSearchValue(getSearchBarObjet(searchText))
            if (location.pathname != '/search') {
                handleRedirectInternal(history, 'search')
            }
            let match,
                pl = /\+/g,
                search = /([^&=]+)=?([^&]*)/g,
                decode = function (s) {
                    return decodeURIComponent(s.replace(pl, ' '))
                },
                query = window.location.search.substring(1)
            let urlParams = {}
            while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2])
            urlParams.search = searchText
            let queryparam = Object.entries(urlParams)
                .map(([key, val]) => `${key}=${val}`)
                .join('&')
            history.replace({
                search: queryparam,
            })
        }
    }

    useEffect(() => {
        if (searchValue && searchValue.filters && searchValue.filters.searchbar) {
            setSearchText(searchValue.filters.searchbar.value)
        }
        // if (searchValue && searchValue.market_status) {
        //     setMenu('past_auction')
        // } else {
        //     setMenu('auction')
        // }
    }, [searchValue])

    useEffect(() => {
        if (isAuthenticated) {
            let auctionFilter = {
                table: 'buynow',
                field: 'id',
                extraField: '',
                filters: {
                    buynow_autype: {
                        value: 'live',
                        type: 'in',
                        field: 'b.buynow_autype',
                    },
                    paid: {
                        value: '0',
                        type: 'in',
                        field: 'b.paid',
                    },
                    partial: {
                        value: '0',
                        type: 'in',
                        field: 'b.partial',
                    },
                },
            }
            let buyNowFilter = {
                table: 'cart_temp',
                field: 'cart_id',
                extraField: '',
                filters: {
                    paid: {
                        value: '0',
                        type: 'in',
                        field: 'crt.paid',
                    },
                },
            }

            loadPendingCount(buyNowFilter, 'buynowCount')

            loadPendingCount(auctionFilter, 'auctionCount')

            if (user.email && window._learnq && window._learnq._loaded) {
                var _learnq = window._learnq || []
                console.log([
                    _learnq,
                    'identify',
                    {
                        $email: user.email,
                    },
                ])
                _learnq.push([
                    'identify',
                    {
                        $email: user.email,
                    },
                ])
            }
        } else {
            let buyNowFilter = {
                table: 'cart_temp_wl',
                field: 'cart_id',
                extraField: '',
                temp_user_id: localStorage?.temp_user_id ? localStorage?.temp_user_id : 0,
                filters: {
                    paid: {
                        value: '0',
                        type: 'in',
                        field: 'crt.paid',
                    },
                },
            }
            if (localStorage?.temp_user_id) {
                loadPendingTempCount(buyNowFilter, 'buynowCount')
            }
        }
    }, [isAuthenticated, history.location.pathname])

    const newRegistration = true

    useEffect(() => {
        if (isAuthenticated) {
            if (northCapitalUser) {
                // if (!northCapitalUser.suitability) {
                //     handleRedirectInternal(history, 'suitability')
                // } else if (!northCapitalUser.kyc_review) {
                //     if (history.location.pathname === '/suitability') {
                //         handleRedirectInternal(history, 'search')
                //     }
                //     if (
                //         northCapitalUser.kycstatus !== 'Approved' &&
                //         northCapitalUser.kycstatus !== 'Auto Approved'
                //     ) {
                //         toggleFullScreenKYCPopup(true, 'new')
                //     }
                // }
                if (user.reg_step_count < 3 && !user.reg_steps_skip.includes('3')) {
                    if (newRegistration) {
                        if (user.skipReg && user.skipReg > 0) {
                            console.log(
                                '[DEBUG skip-registration redirect fired]',
                                new Date().toISOString(),
                                'reg_step_count:',
                                user.reg_step_count,
                                'skipReg:',
                                user.skipReg,
                                'target:',
                                user.skipReg === 1 || user.skipReg == '1' ? 'verify' : 'search',
                            )
                            handleRedirectInternal(
                                history,
                                user.skipReg === 1 || user.skipReg == '1' ? 'verify' : 'search',
                            )
                        }
                    } else {
                        handleRedirectInternal(history, 'registration/Addpayment')
                    }

                    return false
                }
                if (!northCapitalUser.kyc_review) {
                    if (history.location.pathname === '/registration/uploadDocument/1') {
                        handleRedirectInternal(history, 'search')
                    }
                    if (!newRegistration) {
                        // we no longer need this.
                        if (user.is_document_later === 0) {
                            if (user.user_type === 0 && user.domesticYN === 'domestic_account') {
                            } else {
                                handleRedirectInternal(history, 'registration/uploadDocument/1')
                            }
                        }
                    }
                    /*if (
                        northCapitalUser.kycstatus !== 'Approved' &&
                        northCapitalUser.kycstatus !== 'Auto Approved'
                    ) {
                        if (
                            user.kyc_request_count !== 2 &&
                            user.domesticYN === 'domestic_account'
                        ) {
                            handleRedirectInternal(history, 'registration/reupdate')
                        } else {
                            if (user.is_document_later === 0) {
                                handleRedirectInternal(history, 'registration/uploadDocument/1')
                            }
                        }
                    }*/
                }
            }
        }
    }, [isAuthenticated, northCapitalUser, history.location.pathname])

    const [count, setCount] = useState({
        auctionCount: 0,
        buynowCount: 0,
    })

    useEffect(() => {
        if (cartCount?.auctionCount) {
            setCount({ ...count, auctionCount: cartCount.auctionCount.totalRecords })
        }
        if (cartCount?.buynowCount) {
            setCount({ ...count, buynowCount: cartCount.buynowCount.totalRecords })
        }
    }, [cartCount])

    useEffect(() => {
        if (cartTempCount?.buynowCount && !isAuthenticated && localStorage.temp_user_id) {
            setCount({ ...count, buynowCount: cartTempCount.buynowCount.totalRecords })
            if (cartTempCount.buynowCount.totalRecords) {
                localStorage.setItem('cartTempCount', cartTempCount.buynowCount.totalRecords)
            } else {
                localStorage.removeItem('cartTempCount')
            }
        } else {
            setCount({
                auctionCount: 0,
                buynowCount: 0,
            })
            localStorage.removeItem('cartTempCount')
        }
    }, [cartTempCount])

    const handleMenuToggle = (activeMenu) => {
        setAucOpen((prevOpen) => !prevOpen)
        setMenu(activeMenu)
    }

    const handleMenuClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }
        setAucOpen(false)
    }

    const setValue = (value) => {
        if (location.pathname !== '/search') {
            handleRedirectInternal(history, 'search')
        }
        {
            window.location.pathname == '/search'
                ? (getAllSearchProducts(listHandle(value)),
                  setAucOpen(false),
                  setSearchValue(listHandle(value)))
                : null
        }
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault()
            setAucOpen(false)
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(aucopen)
    React.useEffect(() => {
        if (prevOpen.current === true && aucopen === false) {
            anchorRef.current.focus()
        }

        prevOpen.current = aucopen
    }, [aucopen])

    const [manageKYC, setManageKYC] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenKYCPopup = (popup, status, data) => {
        setManageKYC({ popup, status, data })
    }

    useEffect(() => {
        if (isAuthenticated && freeOffers.length && enableOneof) {
            if (!localStorage.getItem('confirmPopup')) {
                if (!localStorage.getItem('popup')) {
                    setFreePopup(true)
                    setFreeData(freeOffers)
                    localStorage.setItem('popup', true)
                }
            }
        }
    }, [freeOffers, isAuthenticated])

    const handlePopupClose = () => {
        updateProfile(
            {
                purchase_blocked: 0,
            },
            true,
        )

        setRestrictPopup(false)
        handleRedirectInternal(history, 'account/profile')
    }

    /* useEffect(() => {
        if (history.location.search.includes('welcome=1')) {
            setWelcomePopup(true)
        }
    }, []) */

    const mobile = useMediaQuery('(max-width:1200px)')

    const headerRef = useRef(null)
    const [bannerTop, setBannerTop] = useState(70) // Default position

    useEffect(() => {
        const updateBannerPosition = () => {
            if (headerRef.current) {
                const headerBottom = headerRef.current.getBoundingClientRect().bottom
                setBannerTop(Math.max(0, headerBottom)) // Ensure it never goes below 0px
            }
        }

        window.addEventListener('scroll', updateBannerPosition)
        window.addEventListener('resize', updateBannerPosition)

        updateBannerPosition() // Initial call

        return () => {
            window.removeEventListener('scroll', updateBannerPosition)
            window.removeEventListener('resize', updateBannerPosition)
        }
    }, [])

    console.log('rendering header', verify)

    const internationalIndividual =
        user?.user_type == 0 && user?.domesticYN === 'international_account'

    // True when at least one added company owner NEEDS to upload their own document
    // and hasn't yet — this is an action the OWNER still needs to take, not something
    // pending admin review, so it must not be lumped into the "Awaiting Review"
    // banner. isDocumentUploaded !== 1 gates the WHOLE check (not just the
    // non-resident branch): once a document is currently on file for an owner, the
    // ball is in the admin's court regardless of a stale kyc_check_failed count or a
    // stale Disapproved verdict from a prior submission — same principle already
    // applied to company-level documents (a re-uploaded doc means "awaiting fresh
    // review", not "please upload again"), confirmed via real data where
    // kyc_check_failed: 2 and kycstatus: 'Disapproved' persisted alongside
    // isDocumentUploaded: 1 after the owner had already re-submitted.
    const ownerDocumentsMissing =
        user?.user_type == 1 &&
        !!company_owner_data?.record?.length &&
        company_owner_data.record.some(
            (item) =>
                item.isDocumentUploaded !== 1 &&
                (item.kyc_check_failed >= 2 ||
                    item.kycstatus === 'Disapproved' ||
                    item.amlstatus === 'Disapproved' ||
                    item.domicile === 'non-resident'),
        )

    // Picks the "Finish Setup" button's redirect target: /account/profile whenever
    // any owner's kyc_check_failed count has reached 2, regardless of whether their
    // document is currently on file — everyone else (never checked, failed once,
    // non-resident first upload, or KYC/AML simply hasn't run yet) falls through to
    // /verify.
    const ownerRejectedAfterUpload =
        user?.user_type == 1 &&
        !!company_owner_data?.record?.length &&
        company_owner_data.record.some((item) => item.kyc_check_failed >= 2)

    // True for an entity when KYC/AML processing genuinely hasn't started yet —
    // company kycstatus AND amlstatus are both still null, or at least one added
    // owner's kycstatus AND amlstatus are both still null. This is a different state
    // from "submitted and awaiting admin review" (where at least one of those fields
    // has actually resolved to something — Pending, Disapproved, Approved, etc.) — a
    // null/null pair means the check hasn't run at all, so the account is still mid
    // setup, not sitting in a reviewer's queue. Without this, an entity that uploaded
    // its document and added owners but whose KYC/AML simply hadn't been kicked off
    // yet fell into the "same reasoning" owner branch of the Awaiting Review banner
    // below (which only excludes owners with an actionable document gap, not owners
    // who've merely never been checked) and showed "Awaiting verification approval"
    // before any actual review was ever queued.
    // An owner counts as done with their part of setup — not "kyc not yet run" — once
    // kycstatus/amlstatus have actually resolved to something (not both still null)
    // AND, if a document was actually required from them, it's on file. Deliberately
    // does NOT check kyc_check_clicked — that field doesn't reliably increment for an
    // owner who gets approved on the first run (confirmed via real data: an owner who
    // entered correct info and was approved on both kyc and aml still had
    // kyc_check_clicked at 0), so requiring `>= 1` wrongly kept a genuinely-approved
    // owner stuck on "Finish Setup" forever. Whether the resolved status is actually
    // approved vs. Disapproved is a different concern handled elsewhere
    // (ownerDocumentsMissing / ownerRejectedAfterUpload) — this check only cares
    // about "has anything actually happened yet" vs. still null/unqueued.
    // isDocumentUploaded is only checked when a document was actually required — a
    // document is only asked for when kyc_check_failed >= 2 (failed twice, now needs
    // manual/document-based approval) or domicile === 'non-resident' (mirrors
    // OwnerDetails.js's own upload trigger, same as ownerDocumentsMissing above). A
    // resident owner who enters correct info and passes on the first try never
    // uploads anything at all — requiring isDocumentUploaded === 1 unconditionally
    // would keep that owner stuck on "Finish Setup" forever despite being genuinely
    // approved.
    const ownerSetupComplete = (item) => {
        const documentRequired =
            item.kyc_check_failed >= 2 ||
            item.kycstatus === 'Disapproved' ||
            item.amlstatus === 'Disapproved' ||
            item.domicile === 'non-resident'
        return (
            !!(item.kycstatus || item.amlstatus) &&
            (!documentRequired || item.isDocumentUploaded === 1)
        )
    }

    const entityKycNotYetRun =
        user?.user_type == 1 &&
        ((!northCapitalUser?.kycstatus && !northCapitalUser?.amlstatus) ||
            (!!company_owner_data?.record?.length &&
                company_owner_data.record.some((item) => !ownerSetupComplete(item))))

    // Single source of truth for "is this user's KYC/AML genuinely done" — every
    // banner below that needs to know whether the account is approved reads this
    // instead of re-deriving its own copy. Previously each banner (Verify Email, Add
    // Payment, Account Approved) carried its own near-identical but subtly different
    // OR-block, and several of the individual (user_type==0) branches only checked
    // kycstatus without also requiring amlstatus — so a user whose kycstatus resolved
    // to 'Auto Approved' while amlstatus was still pending got treated as "approved"
    // by these banners while the "Awaiting Review" banner (which correctly requires
    // BOTH fields) kept showing too, causing two contradictory banners at once.
    // Requiring both fields for individuals is the strict, correct definition.
    // For entities, the company-level amlstatus check alone isn't enough either —
    // circle.addedCompanyOwners only means owners were ADDED to the system, not that
    // each owner individually passed their own KYC/AML. circle.ownerkycamlChecked
    // (set in markAccuntStatus, already used by the "record label" banner below) is
    // the flag that means every owner record is actually .verified — require it here
    // too, or an entity with company-level AML auto-approved but unverified owners
    // gets shown "Your Account Has Been Approved" while it genuinely isn't.
    // Entities also need their own kycstatus resolved, same as individuals — a null
    // kycstatus with amlstatus only 'Auto Approved' still means admin review hasn't
    // actually happened yet, even if every owner is separately verified.
    const kycGenuinelyApproved =
        !!northCapitalUser &&
        ((user?.user_type == 0 &&
            (northCapitalUser?.kycstatus === 'Approved' ||
                northCapitalUser?.kycstatus === 'Auto Approved' ||
                northCapitalUser?.kycstatus === 'Manually Approved') &&
            (northCapitalUser?.amlstatus === 'Approved' ||
                northCapitalUser?.amlstatus === 'Auto Approved' ||
                northCapitalUser?.amlstatus === 'Manually Approved')) ||
            (user?.user_type == 1 &&
                circle?.ownerkycamlChecked &&
                (northCapitalUser?.kycstatus === 'Approved' ||
                    northCapitalUser?.kycstatus === 'Auto Approved' ||
                    northCapitalUser?.kycstatus === 'Manually Approved') &&
                (northCapitalUser?.amlstatus === 'Approved' ||
                    northCapitalUser?.amlstatus === 'Auto Approved' ||
                    northCapitalUser?.amlstatus === 'Manually Approved')))

    // Used only to pick wording on the "Awaiting Review" banner for entities — the
    // same banner/condition fires whether it's the COMPANY's own kyc/aml still
    // resolving or the OWNERS' individual kyc/aml still resolving (or both), and the
    // text was identical either way ("your documents are under review"), giving the
    // entity user no way to tell which one is actually pending. This flags whether
    // the company side specifically has resolved.
    const companyKycAmlResolved =
        (northCapitalUser?.kycstatus === 'Approved' ||
            northCapitalUser?.kycstatus === 'Auto Approved' ||
            northCapitalUser?.kycstatus === 'Manually Approved') &&
        (northCapitalUser?.amlstatus === 'Approved' ||
            northCapitalUser?.amlstatus === 'Auto Approved' ||
            northCapitalUser?.amlstatus === 'Manually Approved')

    return (
        <div className={`${!isAuthenticated ? 'customClassMobile' : ''}`}>
            {!mobile ? (
                <>
                    <Loaders name="home" isLoading={isLoading} />

                    <header
                        className={
                            'mainHeader d-flex align-items-center justify-content-between px-10'
                        }
                        ref={headerRef}
                    >
                        {(!isAuthenticated || mobile) && (
                            <div className="srchlogoContainer">
                                <a href="https://songvest.com" id="songvest_logo">
                                    <img src={LOGO_WHITE} className="mnLogo cursorDecoy" />
                                </a>
                            </div>
                        )}
                        <div className="navsContainer d-flex align-items-center justify-content-end">
                            <Link className="mnNvlLnks" to="/" id="liveinvestments_link">
                                Explore Offerings
                            </Link>
                            <a
                                className="mnNvlLnks"
                                href="https://www.songvest.com/how-it-works"
                                id="faninvestorbenefits_link"
                            >
                                How it Works
                            </a>
                            <a
                                className="mnNvlLnks"
                                href="https://www.songvest.com/sellroyalties"
                                id="sellingroyalties_link"
                            >
                                Selling Royalties
                            </a>
                            <a
                                className="mnNvlLnks"
                                href="https://www.songvest.com/about-us"
                                id="aboutus_link"
                            >
                                About
                            </a>
                        </div>
                        <div className="profileContainer">
                            <div className={`srchContainer d-flex align-items-center`}>
                                <div className="imageContainer">
                                    <img src="/assets/svg/search_icon.svg" />
                                </div>
                                <input
                                    id="homepage_search_inputfield"
                                    placeholder="Search"
                                    onClick={handleSearchBox}
                                    type="search"
                                    value={searchText}
                                    onChange={handleSearchTextChange}
                                    onKeyDown={handleSearchKeyDown}
                                />
                            </div>
                            {!isAuthenticated ? (
                                <>
                                    <IconButton
                                        className="cartBtn mx-3"
                                        onClick={() => handleClose(history, 'buynowcart')}
                                        id="homepage_cart"
                                    >
                                        <Badge
                                            badgeContent={count.buynowCount || 0}
                                            color="primary"
                                        >
                                            <img src="/assets/svg/shopping-cart.svg" />
                                        </Badge>
                                    </IconButton>
                                    <div className="bfrLgnCont">
                                        <span className="material-icons ml-3 mr-2">
                                            account_circle
                                        </span>
                                        <Link to="/login" id="login_link">
                                            Login
                                        </Link>
                                        <span className="mx-2">/</span>
                                        <Link to="/register" id="register_link">
                                            Register
                                        </Link>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <IconButton
                                        className="cartBtn"
                                        onClick={() => handleClose(history, 'buynowcart')}
                                        id="homepage_cart"
                                    >
                                        <Badge
                                            badgeContent={count.buynowCount || 0}
                                            color="primary"
                                        >
                                            <img src="/assets/svg/shopping-cart.svg" />
                                        </Badge>
                                    </IconButton>
                                    <div
                                        role="button"
                                        ref={mainMenu}
                                        className="acntBtnDrop cursorPointer"
                                        aria-controls="simple-menu"
                                        aria-haspopup="true"
                                        onClick={handleMenu}
                                        id="homepage_profile"
                                    >
                                        <div className="profilePicContainer">
                                            {false ? (
                                                <img className="profilePic" src=""></img>
                                            ) : (
                                                <img
                                                    className="profilePicPlaceholder"
                                                    src="/assets/svg/user_icon.svg"
                                                ></img>
                                            )}
                                        </div>

                                        <span className="userInfo">
                                            {`Hi ${
                                                user?.user_type === 0
                                                    ? capitalizeFirstLetter(user.first_name)
                                                    : capitalizeFirstLetter(user.companyname)
                                            }`}
                                        </span>
                                        <span className="material-icons profileMenu">
                                            expand_more
                                        </span>
                                    </div>
                                    <Popover
                                        id="simple-menu"
                                        anchorEl={mainMenu.current}
                                        keepMounted
                                        className={`headerDropMenu ${
                                            document.body.dir === 'rtl' && 'rtl'
                                        }`}
                                        onClose={handleClose}
                                        open={Boolean(anchormenu)}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                    >
                                        <MenuList
                                            autoFocusItem={open}
                                            id="menu-list-grow"
                                            onKeyDown={handleListKeyDown}
                                        >
                                            {/* <MenuItem
                                                onClick={() => handleClose(history, 'buynowcart')}
                                            >
                                                <img
                                                    src="/assets/svg/myauctions.svg"
                                                    className="mr-2"
                                                />
                                                Cart
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => handleClose(history, 'auctions/all')}
                                            >
                                                <img
                                                    src="/assets/svg/mysongshares.svg"
                                                    className="mr-2"
                                                />
                                                My SongShares
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() =>
                                                    handleClose(history, 'account/profile')
                                                }
                                            >
                                                <span className="material-icons mr-2">person</span>
                                                Profile
                                            </MenuItem> */}
                                            <MenuItem onClick={() => onLogOut()}>
                                                <span className="material-icons mr-2">
                                                    power_settings_new
                                                </span>
                                                Logout
                                            </MenuItem>
                                        </MenuList>
                                    </Popover>
                                </>
                            )}
                        </div>
                    </header>
                </>
            ) : (
                <header className="mainHeader customContainer pt-3 pb-3" ref={headerRef}>
                    {(!isAuthenticated || mobile) && (
                        <div className="srchlogoContainer">
                            {/* <img src="/assets/svg/whitevector.svg" className="logoBack" /> */}
                            <a href="https://songvest.com" id="songvest_logo">
                                <img src={LOGO_WHITE} className="mnLogo cursorDecoy" />
                            </a>
                        </div>
                    )}
                    <div className="navsContainer d-flex align-items-center justify-content-end">
                        {!mobileSmall ? (
                            <div className={`srchContainer d-flex align-items-center mr-3`}>
                                <img className="srchIcon" src="/assets/svg/search.svg" />
                                <input
                                    placeholder="Search"
                                    onClick={handleSearchBox}
                                    type="search"
                                    value={searchText}
                                    onChange={handleSearchTextChange}
                                    onKeyDown={handleSearchKeyDown}
                                />
                            </div>
                        ) : (
                            <IconButton
                                className="mobMenuBtn mr-2"
                                onClick={toggleDrawer('top', true)}
                            >
                                <img className="mobsrchIcon" src="/assets/svg/search.svg" />
                            </IconButton>
                        )}
                        {isAuthenticated && (
                            <IconButton
                                className="cartBtn mr-2"
                                onClick={() => handleClose(history, 'buynowcart')}
                            >
                                <Badge badgeContent={count.buynowCount || 0} color="primary">
                                    <img src="/assets/svg/shopping-cart.svg" />
                                </Badge>
                            </IconButton>
                        )}

                        <IconButton className="mobMenuBtn" onClick={toggleDrawer('left', true)}>
                            <span className="material-icons">menu</span>
                        </IconButton>
                        <SwipeableDrawer
                            anchor={'left'}
                            open={state['left']}
                            onClose={toggleDrawer('left', false)}
                            onOpen={toggleDrawer('left', true)}
                        >
                            <SideNavBar navbarClick={toggleDrawer('left', false)} />
                        </SwipeableDrawer>
                        <SwipeableDrawer
                            className="mblSrchDrawer"
                            anchor={'top'}
                            open={state['top']}
                            onClose={toggleDrawer('top', false)}
                            onOpen={toggleDrawer('top', true)}
                        >
                            <div className={`mblSrchContainer d-flex align-items-center`}>
                                <input
                                    placeholder="Search"
                                    onClick={handleSearchBox}
                                    type="search"
                                    value={searchText}
                                    onChange={handleSearchTextChange}
                                    onKeyDown={handleSearchKeyDown}
                                />
                                <Button
                                    className="btn srchBtn verifyButton"
                                    onClick={handleSearchButtonClick}
                                >
                                    <img className="srchIcon" src="/assets/svg/search.svg" />
                                </Button>
                            </div>
                        </SwipeableDrawer>
                    </div>
                </header>
            )}
            <div
                // style={{
                //     position: 'fixed',
                //     top: `60px`,
                //     width: mobile ? '    100%' : '100%',
                //     // transition: "top 0.3s ease-in-out",
                // }}
                className="verifyBannerParent"
            >
                {!dismissVerifyStartBanner &&
                !verify &&
                user?.user_type == 0 &&
                northCapitalUser &&
                !northCapitalUser?.isDocumentUploaded &&
                // international individual users (documentNeeded) always get the
                // "Upload Personal ID" banner instead, even when Disapproved — this
                // banner's Disapproved branch is domestic-only to avoid showing both
                !(circle?.documentNeeded && circle?.completedCompanyInfo) &&
                (northCapitalUser?.kycstatus == 'Disapproved' || !northCapitalUser?.kycstatus) ? (
                    <div className="verifyBanner">
                        <div className="verifyBannerText">
                            {northCapitalUser?.kycstatus === 'Disapproved'
                                ? user?.kyc_check_failed > 0 && user?.kyc_check_failed % 2 == 0
                                    ? 'Your ID verification is incomplete — please upload your ID documents to complete verification'
                                    : 'Your ID verification was declined — please complete verification again'
                                : 'Set up and verify your identity to start buying SongShares'}
                        </div>
                        <div className="d-flex align-items-center">
                            <Button
                                className="btn srchBtn verifyButton"
                                onClick={() =>
                                    handleRedirectInternal(
                                        history,
                                        northCapitalUser?.kycstatus === 'Disapproved' &&
                                            user?.kyc_check_failed > 0 &&
                                            user?.kyc_check_failed % 2 == 0
                                            ? 'account/profile'
                                            : 'verify',
                                    )
                                }
                            >
                                {northCapitalUser?.kycstatus === 'Disapproved'
                                    ? user?.kyc_check_failed > 0 && user?.kyc_check_failed % 2 == 0
                                        ? 'Upload your ID documents'
                                        : 'Re-verify Identity'
                                    : 'Finish Account Setup'}
                            </Button>
                            <Button
                                id="dialog_closeBtn"
                                className="closeBtn"
                                onClick={() => {
                                    handleVerify()
                                    setDismissVerifyStartBanner(true)
                                }}
                            >
                                <span className="material-icons">close</span>
                            </Button>
                        </div>
                    </div>
                ) : null}

                {!dismissVerifyStartBanner &&
                !verify &&
                user?.user_type == 0 &&
                // international individual users are handled exclusively by the
                // "Upload Personal ID" banner below to avoid showing both at once
                !(circle?.documentNeeded && circle?.completedCompanyInfo) &&
                northCapitalUser?.kycstatus &&
                northCapitalUser?.kycstatus !== 'Disapproved' &&
                northCapitalUser?.kycstatus !== 'Approved' &&
                northCapitalUser?.kycstatus !== 'Auto Approved' &&
                northCapitalUser?.kycstatus !== 'Manually Approved' &&
                !northCapitalUser?.isDocumentUploaded ? (
                    <div className="verifyBanner">
                        <div className="verifyBannerText">
                            {'Upload your ID documents to complete your account setup'}
                        </div>
                        <div className="d-flex align-items-center">
                            <Button
                                className="btn srchBtn verifyButton"
                                onClick={() => handleRedirectInternal(history, 'verify')}
                            >
                                Upload ID Documents
                            </Button>
                            <Button
                                id="dialog_closeBtn"
                                className="closeBtn"
                                onClick={() => {
                                    handleVerify()
                                    setDismissVerifyStartBanner(true)
                                }}
                            >
                                <span className="material-icons">close</span>
                            </Button>
                        </div>
                    </div>
                ) : null}

                {!dismissVerifyStartBanner &&
                !verify &&
                user?.user_type == 1 &&
                northCapitalUser &&
                !circle?.completedCompanyInfo &&
                // Also hide once the company document is actually uploaded, regardless
                // of completedCompanyInfo — that flag is computed from
                // user.socialsecurity/user.domicile (individual-shaped fields) and only
                // resolves true for an entity when user.domicile happens to be exactly
                // 'non-resident'. An international entity whose registration flow lets
                // them upload their document directly, without that field ever getting
                // set, kept completedCompanyInfo stuck false forever — so this banner
                // ("Set up and verify your account") kept showing even after the
                // document was already uploaded, instead of handing off to the next
                // step (Add Company Owners).
                !circle?.uploadedCompanyDetails &&
                northCapitalUser?.kycstatus !== 'Auto Approved' &&
                northCapitalUser?.amlstatus !== 'Auto Approved' &&
                isAuthenticated ? (
                    <div className="verifyBanner">
                        <div className="verifyBannerText">
                            {'Set up and verify your account to start buying SongShares'}
                        </div>
                        <div className="d-flex align-items-center">
                            <Button
                                className="btn srchBtn verifyButton"
                                onClick={() => handleRedirectInternal(history, 'verify')}
                            >
                                Verify Account
                            </Button>
                            <Button
                                id="dialog_closeBtn"
                                className="closeBtn"
                                onClick={() => {
                                    handleVerify()
                                    setDismissVerifyStartBanner(true)
                                }}
                            >
                                <span className="material-icons">close</span>
                            </Button>
                        </div>
                    </div>
                ) : null}

                {!dismissVerifyStartBanner &&
                northCapitalUser &&
                circle?.documentNeeded &&
                circle?.completedCompanyInfo &&
                circle?.uploadedCompanyDetails === false ? (
                    <div className="verifyBanner">
                        <div className="verifyBannerText">
                            {user?.user_type === 0
                                ? 'Upload your Personal ID to complete your account setup'
                                : 'Upload your company documents to complete your account setup'}
                        </div>
                        <div className="d-flex align-items-center">
                            <Button
                                className="btn srchBtn verifyButton"
                                onClick={() =>
                                    handleRedirectInternal(
                                        history,
                                        // kyc/aml never ran yet → first-time upload → /verify
                                        // kyc/aml already ran and failed → re-upload → /account/profile
                                        northCapitalUser?.kycstatus !== 'Disapproved' &&
                                            northCapitalUser?.amlstatus !== 'Disapproved'
                                            ? 'verify'
                                            : 'account/profile',
                                    )
                                }
                            >
                                {user?.user_type === 0 ? 'Upload Personal ID' : 'Upload Documents'}
                            </Button>
                            <Button
                                id="dialog_closeBtn"
                                className="closeBtn"
                                onClick={() => {
                                    handleVerify()
                                    setDismissVerifyStartBanner(true)
                                }}
                            >
                                <span className="material-icons">close</span>
                            </Button>
                        </div>
                    </div>
                ) : null}

                {user?.user_type == 1 &&
                circle?.uploadedCompanyDetails &&
                // === false (confirmed no owners yet), not the truthy-negation
                // !circle?.addedCompanyOwners — addedCompanyOwners starts `null`
                // (unknown) until the owners fetch resolves, and null would also
                // pass `!circle?.addedCompanyOwners`, flashing this banner on for
                // entities that already had owners added, in the gap between
                // uploadedCompanyDetails resolving and company_owner_data arriving.
                circle?.addedCompanyOwners === false &&
                isAuthenticated &&
                !verify ? (
                    <div className="verifyBanner">
                        <div className="verifyBannerText">
                            {'Nearly there! Add your company owners to complete your account setup'}
                        </div>
                        <Button
                            className="btn srchBtn verifyButton"
                            onClick={() => handleRedirectInternal(history, 'verify')}
                        >
                            Add Company Owners
                        </Button>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => handleVerify()}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}

                {!dismissVerifyStartBanner &&
                user?.user_type == 1 &&
                circle?.addedCompanyOwners &&
                (ownerDocumentsMissing || entityKycNotYetRun) &&
                circle?.uploadedCompanyDetails &&
                !kycGenuinelyApproved &&
                isAuthenticated ? (
                    <div className="verifyBanner">
                        <div className="verifyBannerText">
                            {'Pending - Please finish setup steps'}
                        </div>
                        <div className="d-flex align-items-center">
                            <Button
                                className="btn srchBtn verifyButton"
                                onClick={() =>
                                    handleRedirectInternal(
                                        history,
                                        ownerRejectedAfterUpload ? 'account/profile' : 'verify',
                                    )
                                }
                            >
                                Finish Setup
                            </Button>
                            <Button
                                id="dialog_closeBtn"
                                className="closeBtn"
                                onClick={() => setDismissVerifyStartBanner(true)}
                            >
                                <span className="material-icons">close</span>
                            </Button>
                        </div>
                    </div>
                ) : null}

                {/* Entity Disapproved is handled by "Upload Documents" below (not
                uploaded) and "Awaiting Review" further down (re-uploaded, pending
                fresh review) — no separate banner needed here, same as individuals. */}

                {!dismissVerifyStartBanner &&
                northCapitalUser &&
                northCapitalUser?.isDocumentUploaded === 1 &&
                !kycGenuinelyApproved &&
                // Entity accounts must add company owners before this banner can ever
                // apply — "Add Company Owners" is a required step ahead of "Awaiting
                // Review" in the entity priority order. Without this gate, a
                // company-level kyc_admin_review/Disapproved flag set on the document
                // itself (which can happen immediately after upload, before any owner
                // exists) jumped straight to "Awaiting Review" and skipped the
                // "Add Company Owners" banner entirely.
                // Also requires KYC/AML to have actually started (!entityKycNotYetRun)
                // — company kycstatus/amlstatus both null, or any owner's both null,
                // means the check hasn't been queued yet, which is "Finish Setup"
                // territory (see entityKycNotYetRun), not "awaiting a reviewer".
                (user?.user_type !== 1 || (circle?.addedCompanyOwners && !entityKycNotYetRun)) &&
                (user?.kyc_admin_review === 1 ||
                    northCapitalUser?.kycstatus === 'Disapproved' ||
                    northCapitalUser?.amlstatus === 'Disapproved' ||
                    // international individual users have no domestic-style
                    // admin_review flag — show the pending banner as soon as
                    // their document is uploaded and they aren't approved yet
                    internationalIndividual ||
                    // same reasoning for entity users once owners are added AND each
                    // owner has uploaded their own document: AML often auto-approves
                    // at the company level before the owners' individual KYC/AML is
                    // verified (kycGenuinelyApproved requires both), and there's no
                    // admin_review flag for that gap either. Excludes
                    // ownerDocumentsMissing on purpose — if an owner hasn't uploaded
                    // their document yet, that's the "Finish Setup" banner's job, not
                    // this one (owner action needed vs. genuinely awaiting review).
                    // Does NOT gate on kyc_review — verify.js's own equivalent status
                    // logic never checks kyc_review either; it relies purely on
                    // kycstatus/amlstatus (via kycGenuinelyApproved/item.verified), so
                    // Header.js matches that instead of introducing a separate signal.
                    (user?.user_type == 1 &&
                        circle?.addedCompanyOwners &&
                        !ownerDocumentsMissing)) &&
                isAuthenticated ? (
                    <div className="verifyBanner">
                        <div className="verifyBannerText">
                            {user?.user_type === 1
                                ? !companyKycAmlResolved && !circle?.ownerkycamlChecked
                                    ? 'Awaiting verification approval — your company and owner documents are under review'
                                    : !companyKycAmlResolved
                                    ? 'Awaiting verification approval — your company documents are under review'
                                    : 'Awaiting verification approval — your owner documents are under review'
                                : 'Awaiting verification approval — your documents are under review'}
                        </div>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => setDismissVerifyStartBanner(true)}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}

                {northCapitalUser &&
                !verify &&
                (kycGenuinelyApproved ||
                    (dismissVerifyStartBanner && northCapitalUser?.isDocumentUploaded === 1)) &&
                !user?.mail_verified &&
                (user?.user_type !== 1 || circle?.addedCompanyOwners) &&
                isAuthenticated ? (
                    <div className="verifyBanner">
                        <div className="verifyBannerText">
                            {
                                'You`re so close! Verify your email address to finish setting up your account setup and start buying SongShares'
                            }
                        </div>
                        <Button
                            className="btn srchBtn verifyButton"
                            onClick={() => handleEmailVerify()}
                        >
                            Resend Email Verification
                        </Button>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => handleVerify()}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}

                {northCapitalUser &&
                !verify &&
                (kycGenuinelyApproved ||
                    (dismissVerifyStartBanner && northCapitalUser?.isDocumentUploaded === 1)) &&
                circle?.setupPaymentMethod === false &&
                user?.mail_verified &&
                (user?.user_type !== 1 || circle?.addedCompanyOwners) &&
                isAuthenticated &&
                !verify ? (
                    <div className="verifyBanner">
                        <div className="verifyBannerText">
                            {
                                'You`re so close! Add a payment method to finish setting up your account setup and start buying SongShares'
                            }
                        </div>
                        <Button
                            className="btn srchBtn verifyButton"
                            onClick={() => handleRedirectInternal(history, 'paymentinfo')}
                        >
                            Add Payment Method
                        </Button>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => handleVerify()}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}

                {northCapitalUser &&
                // unlike the Verify Email / Add Payment banners, this banner is purely
                // informational (no required action) — it must NOT reuse the
                // dismissVerifyStartBanner fallback, or dismissing banner 3 ("Awaiting
                // verification approval") immediately re-shows an equivalent "still
                // under review" message here, which is the redundant double-banner
                // this gate previously caused. Only show once genuinely approved.
                kycGenuinelyApproved &&
                (dismissVerifyStartBanner ||
                    !(
                        user?.kyc_admin_review === 1 ||
                        northCapitalUser?.kycstatus === 'Disapproved' ||
                        northCapitalUser?.amlstatus === 'Disapproved'
                    )) &&
                isAuthenticated &&
                !accountPopup &&
                !user?.kyc_aml_ribbon_status &&
                // Individuals: show as soon as KYC/AML is genuinely approved — this
                // banner no longer waits on email verification or a payment method
                // for them, so it can appear alongside the Verify Email / Add
                // Payment banners instead of only after both are done. Entities
                // still require mail_verified + a payment method + addedCompanyOwners,
                // unchanged from before.
                (user?.user_type === 1
                    ? user?.mail_verified &&
                      circle?.setupPaymentMethod !== false &&
                      circle?.addedCompanyOwners
                    : true) ? (
                    <div
                        className="verifyBanner"
                        // style={{
                        //     position: 'fixed',
                        //     top: `${bannerTop}px`,
                        //     width: mobile ? '100%' : 'calc(100% - 222px)',
                        //     // transition: "top 0.3s ease-in-out",
                        // }}
                    >
                        <div className="verifyBannerText">
                            {kycAdminReview
                                ? 'Your Account Verification Is In Review'
                                : 'Your Account Has Been Approved'}
                        </div>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => {
                                updateProfile(
                                    {
                                        kyc_aml_ribbon_status: 1,
                                    },
                                    true,
                                )
                                setAccountPopup(true)
                            }}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}
                {kycGenuinelyApproved &&
                circle?.setupPaymentMethod &&
                circle?.emailVerified &&
                // Only after the "Account Approved" banner has actually been seen
                // (accountPopup, local dismiss) or persisted-dismissed
                // (kyc_aml_ribbon_status) — this banner's own condition used to be a
                // near-subset of banner 6's (kycamlChecked/ownerkycamlChecked +
                // setupPaymentMethod + emailVerified vs. kycGenuinelyApproved +
                // mail_verified + setupPaymentMethod), with no exclusion between them,
                // so a freshly-approved user with payment set up could see both
                // banners stacked at once — the one documented exception to "only ONE
                // banner visible at a time" is the individual Approved-banner
                // decoupling from email/payment, not this.
                (accountPopup || user?.kyc_aml_ribbon_status) &&
                (user?.user_type !== 1 || circle?.addedCompanyOwners) &&
                !verify &&
                isAuthenticated &&
                !user?.record_label_shown &&
                !hideRecord &&
                showRecord ? (
                    <div
                        className="verifyBanner"
                        // style={{
                        //     position: 'fixed',
                        //     top: `${bannerTop}px`,
                        //     width: mobile ? '100%' : 'calc(100% - 222px)',
                        //     // transition: "top 0.3s ease-in-out",
                        // }}
                    >
                        <div className="verifyBannerText">
                            {'Did you know you can create your own public record label ?'}
                        </div>
                        <Button
                            className="btn srchBtn verifyButton recordButton"
                            onClick={async () => {
                                if (location.pathname !== '/account/profile') {
                                    await handleRedirectInternal(
                                        history,
                                        'account/profile/#recordLabelForm',
                                    )
                                    // The route change above doesn't wait for the
                                    // destination page to actually mount
                                    // #recordLabelForm — without a delay,
                                    // getElementById returns null and the scroll
                                    // silently no-ops on the first click from any
                                    // other page.
                                    setTimeout(() => {
                                        document
                                            .getElementById('recordLabelForm')
                                            ?.scrollIntoView({ behavior: 'smooth' })
                                    }, 500)
                                    return
                                }

                                document
                                    .getElementById('recordLabelForm')
                                    ?.scrollIntoView({ behavior: 'smooth' })
                            }}
                        >
                            Click Here to Learn How
                        </Button>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => {
                                // hideRecord was declared but never set anywhere —
                                // updateProfile only persists the dismissal to the
                                // backend, it doesn't update the local `user` object,
                                // so the banner (gated on !user?.record_label_shown)
                                // kept showing until a refresh re-fetched the user.
                                // setHideRecord(true) hides it immediately client-side,
                                // matching the pattern the "Account Approved" banner's
                                // close button already uses (setAccountPopup(true)
                                // alongside its own updateProfile call).
                                setHideRecord(true)
                                updateProfile({ record_label_shown: 1 }, true)
                            }}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}
            </div>
            <KYCUpdate data={manageKYC} function={toggleFullScreenKYCPopup} />
            <CustomDialog
                className="alert"
                title="Note"
                open={toggleDialogCanada}
                function={() => setToggleDialogCanada(false)}
            >
                <div className="bidCnfModalCnt">
                    <h5>{`Canadian users cannot ${canadaUserErrorMessage} at this time.`}</h5>
                </div>

                <div className="actionWrapper mt-1">
                    <PrimaryButton onClick={() => setToggleDialogCanada(false)}>
                        Close
                    </PrimaryButton>
                </div>
            </CustomDialog>
            {/* <FreeShares
                open={freePopup}
                openFunction={() => setFreePopup(false)}
                data={freeData}
                user={user}
            /> */}
            <FormDialog
                className="freeSharePopup wlcmPopup"
                open={restrictPopup}
                handleClose={() => handlePopupClose()}
                maxWidth={'sm'}
            >
                <div className="wlcmCntnr">
                    <img src={LOGO} />
                    <h2>Please update your address and contact info.</h2>
                    <p>
                        To purchase shares you have to pass the SEC &quot;Know Your Customer&quot;
                        (KYC) and &quot;Anti Money Laundering&quot; (AML) test by having the correct
                        address information entered in the system. Go to your settings page to
                        confirm it has been completed and your auto purchase will complete.{' '}
                    </p>
                    <Button className="btn srchBtn verifyButton" onClick={handlePopupClose}>
                        Continue
                    </Button>

                    {/* <p>Thank you for registering an account with us!</p> */}
                </div>
            </FormDialog>
            <FormDialog
                className="freeSharePopup wlcmPopup"
                open={welcomePopup}
                handleClose={() => setWelcomePopup(false)}
                maxWidth={'sm'}
            >
                <div className="wlcmCntnr">
                    <img src={LOGO} />
                    <h2>Welcome To SongVest!</h2>
                    <p>Thank you for registering an account with us!</p>
                    <p>
                        You&apos;re now on your way to taking part in the success and journey of
                        some of your favorite artists.
                    </p>
                    <p>
                        We&apos;re glad to have you here and we look forward to providing you with
                        exciting offerings that you can be a part of!
                    </p>
                </div>
            </FormDialog>
            <BidHistory />
            <TTWBidHistory />
        </div>
    )
}
export default Header
